import { useTheme } from "@chakra-ui/react"
import { memo } from "react"

type CurvedTitleProps = {
  title?: string
  brandColor?: string
  fontSize?: string
}

// See https://css-tricks.com/snippets/svg/curved-text-along-path/
// and https://yqnn.github.io/svg-path-editor/
const CurvedTitle: React.FC<CurvedTitleProps> = ({ title, brandColor = "avocado", fontSize = "9xl" }) => {
  const theme = useTheme()

  if (!title) return null

  const colorHex = theme.colors.brand[brandColor]

  {
    /* alternative curve: M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97 */
  }
  const path = "M 73.2 148.6 c 10.8 -15.6 56.8 -53.6 174.8 -58.6 c 119 5 167 42 178 59"
  // const path = "M 74 198 c 10.8 -15.6 41 -79 165 -105 c 114 10 167 42 187 106"

  return (
    <svg viewBox="0 0 500 200">
      {/* eslint-disable */}
      <path fill="transparent" id="curve" d={path} />
      <text fill={colorHex} fontSize={theme.fontSizes[fontSize]} fontFamily={theme.fonts.heading}>
        {/* See https://stackoverflow.com/questions/71281977/how-do-i-center-text-along-an-svg-curve */}
        <textPath xlinkHref="#curve" startOffset="50%" dominantBaseline="middle" textAnchor="middle">
          {title}
        </textPath>
      </text>
    </svg>
  )
}

const MemoCurvedTitle = memo(CurvedTitle)
export { MemoCurvedTitle as CurvedTitle }
